export { default } from "./useSchoolThroughUserQuery";
